const CONSECUTIVE_TRIPS_URL = 'https://europe-west3-rally-scan.cloudfunctions.net/find_consecutive_trips';

export const findConsecutiveTrips = async (params) => {
  const response = await fetch(CONSECUTIVE_TRIPS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      n_rallies: params.numRallies,
      max_days_between_rallies: params.maxPauseDays,
      max_days_overlap: params.maxOverlapDays,
      return_to_start: params.returnToStart,
      enable_nearby: params.enableNearby,
      radius_km: params.radiusKm
    })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch consecutive trips');
  }

  return response.json();
}; 